import styled from "styled-components";

import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { colors } from "@/Utils";

const Wrapper = styled.div`
  display: flex;
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
  opacity: ${(props) => (props.disabled ? 0.3 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  background: ${(props) => (props.background ? props.background : `transparent`)};
  height: ${(props) => (props.height ? `${props.height}px` : `auto`)};
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : "auto")};

  padding-left: ${(props) => (props.pdleft ? `${props.pdleft}px` : `0px`)};
  padding-bottom: ${(props) => (props.pdbottom ? `${props.pdbottom}px` : `0px`)};
  padding-right: ${(props) => (props.pdright ? `${props.pdright}px` : `0px`)};
  padding-top: ${(props) => (props.pdtop ? `${props.pdtop}px` : `0px`)};
  margin-right: ${(props) => (props.mrright ? `${props.mrright}px` : "0")};
  margin-left: ${(props) => (props.mrleft ? `${props.mrleft}px` : "0")};
  svg {
    g {
      g {
        transition: all 0.5s ease-in-out;
      }
    }
  }
  &:hover {
    svg {
      g {
        g {
          fill: ${(props) => (props.hoverColor ? props.hoverColor : "#ffd401")};
        }
      }
    }
  }
`;

export const Mountain = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_Mountain">
        <defs>
          <path
            d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
            id="mountain_a"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="mountain_b" fill="#fff">
            <use xlinkHref="#mountain_a" />
          </mask>
          <g mask="url(#mountain_b)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const MoneyIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_MoneyIcon">
        <g fill="none" fillRule="evenodd" transform="translate(6 3)">
          <g fill="#FFD400" mask="url(#b)">
            <path
              id="a"
              d="M5.8 7.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21C10.14 4.28 9.09 2.7 7 2.19V0H4v2.16C2.06 2.58.5 3.84.5 5.77c0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1H.32c.12 2.19 1.76 3.42 3.68 3.83V18h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
            />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const EyeIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24px" height="24px" viewBox="0 0 24 24" data-testcomp="Icon_EyeIcon">
        <g
          id="Action/ic_visibility-Copy"
          stroke="none"
          strokeWidth="1"
          fill="#FFD400"
          fillRule="evenodd"
        >
          <path
            d="M12,4.5 C7,4.5 2.73,7.61 1,12 C2.73,16.39 7,19.5 12,19.5 C17,19.5 21.27,16.39 23,12 C21.27,7.61 17,4.5 12,4.5 L12,4.5 Z M12,17 C9.24,17 7,14.76 7,12 C7,9.24 9.24,7 12,7 C14.76,7 17,9.24 17,12 C17,14.76 14.76,17 12,17 L12,17 Z M12,9 C10.34,9 9,10.34 9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 L12,9 Z"
            id="path-1"
          ></path>
        </g>
      </svg>
    </Wrapper>
  );
};

export const ArrowUpIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_ArrowUpIcon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="zrbhlq2ocb" d="m7 14 5-5 5 5z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="t4967yszsc" fill="#fff">
            <use xlinkHref="#zrbhlq2ocb" />
          </mask>
          <g mask="url(#t4967yszsc)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const ArrowDownIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_ArrowDownIcon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="5bkdl6seoa" d="m7 10 5 5 5-5z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="17spj56erb" fill="#fff">
            <use xlinkHref="#5bkdl6seoa" />
          </mask>
          <g mask="url(#17spj56erb)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const TrafficLight = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_TrafficLight"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 19zm0-5a2 2 0 1 1-.001-3.999A2 2 0 0 1 12 14zm0-5a2 2 0 0 1-2-2c0-1.11.89-2 2-2a2 2 0 1 1 0 4z"
            id="8shx8sdo2a"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="wjcvh906pb" fill="#fff">
            <use xlinkHref="#8shx8sdo2a" />
          </mask>
          <g mask="url(#wjcvh906pb)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const BubbleAllOut = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_BubbleAllOut"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="m16.21 4.16 4 4v-4h-4zm4 12-4 4h4v-4zm-12 4-4-4v4h4zm-4-12 4-4h-4v4zm12.95-.95a7.007 7.007 0 0 0-9.9 0 7.007 7.007 0 0 0 0 9.9 7.007 7.007 0 0 0 9.9 0c2.73-2.73 2.73-7.16 0-9.9zm-1.1 8.8a5.438 5.438 0 0 1-7.7 0 5.438 5.438 0 0 1 0-7.7 5.438 5.438 0 0 1 7.7 0 5.438 5.438 0 0 1 0 7.7z"
            id="u4f34wi02a"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="d9g60jaxyb" fill="#fff">
            <use xlinkHref="#u4f34wi02a" />
          </mask>
          <g mask="url(#d9g60jaxyb)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const FlashIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_FlashIcon"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="wwqjfmkq6a" d="M7 2v11h3v9l7-12h-4l4-8z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="i1shg1eahb" fill="#fff">
            <use xlinkHref="#wwqjfmkq6a" />
          </mask>
          <g mask="url(#i1shg1eahb)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const MergeArrowUp = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_MergeArrowUp"
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M17 20.41 18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
            id="asdfadsfasdfadf"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="asdfhk9afsdfkh" fill="#fff">
            <use xlinkHref="#asdfadsfasdfadf" />
          </mask>
          <g mask="url(#asdfhk9afsdfkh)" fill="#FFD400">
            <path d="M-13-13h50v50h-50v-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const RightTriangle = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_RightTriangle">
        <g fill="none" fillRule="evenodd">
          <g opacity=".3" transform="translate(2 2)">
            <g fill="#FFD400" mask="url(#b)">
              <path id="a" d="M0 20h20V0z" />
            </g>
          </g>
          <g transform="translate(2 7)">
            <g fill="#FFD400" mask="url(#d)">
              <path id="c" d="M15 0L0 15h15z" />
            </g>
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const Earth = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_Earth">
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
          <g fill="#FFD400" mask="url(#prefix__b)">
            <path
              id="prefix__a"
              d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM9 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L7 13v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H6V8h2c.55 0 1-.45 1-1V5h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const TabAddIcon = (props) => {
  const { theme } = useInfo();
  return (
    <Wrapper
      {...props}
      height={37}
      background={theme.mode === "dark" ? colors.darkGray : "transparent"}
      style={{
        position: "relative",
        clipPath: "polygon(30% 0px, 100% 0px, 100% 100%, 0px 100%, 0px 45%)",
      }}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_TabAdd">
        <g fill="none" fillRule="evenodd" transform="translate(5 5)">
          <g fill={theme.mode === "light" ? "#d8d8d8" : theme.color} mask="url(#prefix__b)">
            <path id="prefix__a" d="M14 8L8 8 8 14 6 14 6 8 0 8 0 6 6 6 6 0 8 0 8 6 14 6z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const CardView = (props) => {
  const { theme } = useInfo();

  return (
    <Wrapper {...props} className="dashboard__card-switcher--icon">
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_CardView">
        <defs>
          <path
            d="M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
            id="card_view_a"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="card_view_b" fill="#fff">
            <use xlinkHref="#card_view_a" />
          </mask>
          <g mask="url(#card_view_b)" fill={theme.mode === "dark" ? "white" : "black"}>
            <path d="M-13-13h50v50h-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const TableView = (props) => {
  const { theme } = useInfo();

  return (
    <Wrapper {...props} data-testcomp="Icon_TableView">
      <svg width="24" height="24" viewBox="0 0 24 24">
        <defs>
          <path
            d="M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
            id="table_view_a"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="table_view_b" fill="#fff">
            <use xlinkHref="#table_view_a" />
          </mask>
          <g mask="url(#table_view_b)" fill={theme.mode === "dark" ? "white" : "black"}>
            <path d="M-13-13h50v50h-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const SquareBarIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_SquareBarIcon">
        <g fill="none" fillRule="evenodd">
          <g fill="#FFD400" mask="url(#x16y2mqyjb)">
            <path
              id="ujgm0kss1a"
              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
            />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const TickIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        data-testcomp="Icon_TickIcon"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="veokk8rxea" d="M6 10.78 3.22 8l-.947.94L6 12.667l8-8-.94-.94z" />
        </defs>
        <g transform="translate(0 .5)" fill="none" fillRule="evenodd">
          <mask id="f89n3ppkjb" fill="#fff">
            <use xlinkHref="#veokk8rxea" />
          </mask>
          <g mask="url(#f89n3ppkjb)" fill="#000">
            <path d="M-8.667-8.667h33.333v33.333H-8.667z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const Filter = (props) => {
  const { theme } = useInfo();

  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_Filter">
        <defs>
          <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" id="filter_icon_a" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="filter_icon_b" fill="#fff">
            <use xlinkHref="#filter_icon_a" />
          </mask>
          <g mask="url(#filter_icon_b)" fill={theme.mode === "dark" ? "white" : "black"}>
            <path d="M-13-13h50v50h-50z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const EditIcon = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="16" height="16" viewBox="0 0 16 16" data-testcomp="Icon_EditIcon">
        <g fill="none" fillRule="evenodd" transform="translate(3 3)">
          <g fill="#B4B3B4" mask="url(#prefix__b)">
            <path
              id="a"
              d="M0 10.5V13h2.5l7.373-7.373-2.5-2.5L0 10.5zm11.807-6.807c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 0 0-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22z"
            />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const LightMode = (props) => {
  return (
    <Wrapper {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_LightMode">
        <g fill="none" fillRule="evenodd">
          <g>
            <g transform="translate(-40.000000, -392.000000) translate(40.000000, 392.000000)">
              <g fill="#FFD400" mask="url(#heozu19bcb)">
                <path
                  id="lzgm9z6xja"
                  d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const DarkMode = (props) => {
  return (
    <Wrapper {...props} hoverColor="white">
      <svg width="24" height="24" viewBox="0 0 24 24" data-testcomp="Icon_DarkMode">
        <g fill="none" fillRule="evenodd" opacity=".646">
          <g>
            <g transform="translate(-40.000000, -392.000000) translate(39.719431, 391.552082)">
              <g fill="#666667" mask="url(#t369ua6e9b)">
                <path
                  id="vnpdpy41aa"
                  d="M12.278 3.681c.94.004 1.847.155 2.699.43-3.698.57-6.52 3.76-6.504 7.613.018 4.266 3.51 7.749 7.788 7.766.624.003 1.231-.069 1.813-.206-1.54 1.303-3.539 2.085-5.723 2.076-4.89-.02-8.88-4-8.9-8.876-.02-4.876 3.937-8.823 8.827-8.803zm5.2 5.161l1.662 1.39 2.077-.885-.885 2.076 1.39 1.662-2.215-.102-1.222 1.917-.478-2.143-2.144-.479 1.918-1.221-.102-2.215z"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const KeyboardArrowUp = (props) => {
  const { theme } = useInfo();

  const color = theme.mode === "dark" ? "white" : "black";
  return (
    <Wrapper {...props} hoverColor={color}>
      <svg
        data-testcomp="Icon_KeyboardArrowUp"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="muec196nla" d="M4.94 10.273 8 7.22l3.06 3.053.94-.94-4-4-4 4z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="uty6qqzw2b" fill="#fff">
            <use xlinkHref="#muec196nla" />
          </mask>
          <g mask="url(#uty6qqzw2b)" fill={color}>
            <path d="M-8.667-8.667h33.333v33.333H-8.667z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

export const KeyboardArrowDown = (props) => {
  const { theme } = useInfo();
  const color = theme.mode === "dark" ? "white" : "black";

  return (
    <Wrapper {...props} hoverColor={color}>
      <svg
        data-testcomp="Icon_KeyboardArrowDown"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="d1glnyqssa" d="M4.94 5.658 8 8.588l3.06-2.93.94.902-4 3.84-4-3.84z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <mask id="pfy0zpal6b" fill="#fff">
            <use xlinkHref="#d1glnyqssa" />
          </mask>
          <g mask="url(#pfy0zpal6b)" fill={color}>
            <path d="M-8.667-8.32h33.333v32H-8.667z" />
          </g>
        </g>
      </svg>
    </Wrapper>
  );
};

// export const temp = (props) =>{
//     return <Wrapper {...props}></Wrapper>
// }
